/* eslint-disable no-undef */
(function (window) {
    "use strict";
    function defineProductService() {
        let productService = {};
        productService.getProducts = function (request){
            return axios.post("/api/ProductService/GetProducts", request);
        };
        productService.getProduct = function (productId){
            return axios.get("/api/ProductService/GetProduct?productId=" + productId);
        };
        productService.getCompanyShippingAddressPrices = function (request){
            return axios.post("/api/ProductService/GetCompanyShippingAddressPrices", request);
        };
        productService.getZoneProductBasePricesWithShippingAddresses = function (request){
            return axios.post("/api/ProductService/GetZoneProductBasePricesWithShippingAddresses", request);
        };
        return productService;
    }
    //define globally if it doesn't already exist
    if (typeof (productService) === "undefined") {
        window.productService = defineProductService();
    } else {
        console.log("productService already defined.");
    }
})(window);